/** @jsxImportSource @emotion/react */
import { Button, useTheme } from '@quickbit/qb-design-system';
import { useNavigate } from 'react-router-dom';

export const MfaCompleted = () => {
  const { spacing } = useTheme();
  const navigate = useNavigate();

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: spacing.m,
        backgroundColor: 'white',
      }}
    >
      <p>
        Two-Factor Authentication (2FA) has been successfully enabled on your
        account. Your account is now more secure!
      </p>
      <div css={{ display: 'inline-block', marginTop: spacing.xs }}>
        <Button text="Finish" onClick={() => navigate('/settings/security')} />
      </div>
    </div>
  );
};
